import axios from 'axios';
import Cookies from 'js-cookie';

import { getBaseUrl } from '@/api';

export const createAxiosInstance = (token?: string) => {
  const instance = axios.create({
    baseURL: getBaseUrl(),
    timeout: 10000,
  });

  instance.interceptors.request.use(
    (config) => {
      const currentToken = token || Cookies.get('accessToken');
      if (currentToken) {
        config.headers.Authorization = `Bearer ${currentToken}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  return instance;
};